//--------------------------------------------------
// imported classes
//--------------------------------------------------
const Common = require('@/tbs/model/to/Common')
const ClassFunc = require('@/tbs/util/ClassFunc')

/**
 * The Player class works as the player translator.
 */
const tbs_model_to_Staff = function() {
    //--------------------------------------------------
    // super method for the base class
    //--------------------------------------------------
    ClassFunc.super(this, Common, arguments);
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_model_to_Staff.prototype = {
    'role-option-0': '超级管理员',
    'role-option-1': '管理员',
    'role-option-2': '赛事运营',
    'staff-empty-hint': '暂无工作人员，新建人员',
    'staff-name-required': '请填写人员名称',
    'staff-name-label': '人员名称',
    'staff-name-placeholder': '人员名称',
    'staff-logo-label': '人员照片',
    'staff-logo-placeholder': '标准头像照，建议图片大小300X400 PX',
    'staff-remark-label': '备注（可选）',
    'staff-remark': '备注',
    'staff-remark-placeholder': '备注说明内容',
    'staff-role-label': '管理角色',
    'staff-role-required': '请选择管理角色',
    'delete-staff': '删除工作人员',
    'delete-staff-confirm-message': '确认删除该工作人员，无法进行还原',
    'staff-invite-label': '未入驻激活 | 立即邀请',
    'match-grant': '添加权限',
    'match-revoke': '移除权限',
    'match-permission': '赛事权限',
    'staff-match-empty-hint': '暂无赛事权限，添加权限',
    'staff-invite-title': '邀请成为[$role]',
    'staff-entry-year': '$year年入驻',
    'match-signup-top': '赛事',
    'match-signup-bottom': '报名',
    'team-registration-top': '球队',
    'team-registration-bottom': '注册',
    'match-schedule-top': '赛程',
    'match-schedule-bottom': '榜单',
    'match-notification-top': '赛事',
    'match-notification-bottom': '通知',
    'live-broadcast-top': '直播',
    'live-broadcast-bottom': '镜头',
    'sports-insurance-top': '运动',
    'sports-insurance-bottom': '保险',
    'invite-staff-as-role': '邀请你成为[$role]',
    'join-us': '立即加入',
    'welcome-title': '成功成为[$role]',
    'welcome-organization': '[$organization]',
    'download': '下载',
    'download-app-title': '斑马邦 · 开始赛事管理',
    'feature-item-org': '协会注册报名',
    'feature-item-live': '智能直播实况',
    'feature-item-fee': '赛事报名收费',
    'feature-item-stats': '数据分析统计',
    'feature-item-schedule': '赛程积分榜单',
    'feature-item-insurance': '赛事定制保险',
    'download-app-label': '赛事管理需下载斑马邦APP',
    'download-now': '立即下载',
}

//--------------------------------------------------
// extends the Common
//--------------------------------------------------
ClassFunc.extend(tbs_model_to_Staff, Common);

module.exports = tbs_model_to_Staff